import { useSelector } from 'react-redux';

import Narratives from '../../../Narratives';
import NarrativesChat from '../../index';

// Temporary component to show Chat UI for Numeration.
// Landing page and Chat UI will need to be consolidated for final version.
const NarrativesRoute = () => {
  const { permissions = {} } = useSelector((state) => state?.user?.data) || {};
  const { canAccessBuildYourOwn, canAccessChat } = permissions;

  return canAccessBuildYourOwn || canAccessChat ? (
    <NarrativesChat hasChatAccess={canAccessChat} />
  ) : (
    <Narratives />
  );
};

export default NarrativesRoute;
